export default "__VITE_ASSET__9bbeec88__"